import mobileImage from 'public/assets/featured-properties/internal-promo-cards/mobile.jpeg';
import smartMapImage from 'public/assets/featured-properties/internal-promo-cards/smartmap.jpeg';
import newHomeImage from 'public/assets/featured-properties/internal-promo-cards/newhome.jpeg';

export const internalPromoIds = ['mobile', 'smartmap', 'newhomes'] as const;
export type InternalPromoId = typeof internalPromoIds[number];

export type InternalPromoData = {
    name: string;
    title: string;
    details: string;
    cta: string;
    image: {
        src: string;
        caption?: string | null;
        responsiveImgList?: {
            width: number;
            src: string;
        }[];
    };
    link: string;
};

export const internalPromos: Record<InternalPromoId, InternalPromoData> = {
    mobile: {
        name: 'mobile',
        title: 'Zoopla app',
        details: 'Download our free mobile apps for property info on the go',
        cta: 'Download the app',
        image: {
            src: mobileImage
        },
        link: 'mobile/'
    },
    smartmap: {
        name: 'smartmap',
        title: 'Draw your search',
        details: 'Pinpoint exactly where to live by using our SmartMaps search',
        cta: 'Draw your search',
        image: {
            src: smartMapImage
        },
        link: 'map'
    },
    newhomes: {
        name: 'newhomes',
        title: 'New Homes',
        details: 'Find new homes from thousands of UK developments',
        cta: 'Search new homes',
        image: {
            src: newHomeImage
        },
        link: 'new-homes'
    }
} as const;
